<template>
  <div v-if="hasCustomFields">
    <div v-if="wheelsetOptions.riderWeight.length > 0" class="mt-7">
      <p class="block small mt-4 mb-1">Rider Weight</p>
      <UiCustomDropdown 
        :option="{ values: wheelsetOptions.riderWeight }" 
        class="w-full" 
        :selectedOption="modelValue.riderWeight"
        @change="(value) => updateField('riderWeight', value)"
      />
    </div>

    <div v-if="wheelsetOptions.rimType.length > 0" class="mt-7">
      <p class="block small mt-4 mb-1">Rim Type</p>
      <UiCustomDropdown 
        :option="{ values: wheelsetOptions.rimType }" 
        class="w-full" 
        :selectedOption="modelValue.rimType"
        @change="(value) => updateField('rimType', value)"
      />
    </div>

    <div v-if="wheelsetOptions.rimHeight.length > 0" class="mt-7">
      <p class="block small mt-4 mb-1">Rim Height</p>
      <UiCustomDropdown 
        :option="{ values: wheelsetOptions.rimHeight }" 
        class="w-full" 
        :selectedOption="modelValue.rimHeight"
        @change="(value) => updateField('rimHeight', value)"
      />
    </div>

    <div v-if="wheelsetOptions.tireWidth.length > 0" class="mt-7">
      <p class="block small mt-4 mb-1">Intended Tire Width</p>
      <UiCustomDropdown 
        :option="{ values: wheelsetOptions.tireWidth }" 
        class="w-full" 
        :selectedOption="modelValue.tireWidth"
        @change="(value) => updateField('tireWidth', value)"
      />
    </div>

    <div v-if="wheelsetOptions.rimBrand.length > 0" class="mt-7">
      <p class="block small mt-4 mb-1">Preferred Rim Brand</p>
      <UiCustomDropdown 
        :option="{ values: wheelsetOptions.rimBrand }" 
        class="w-full" 
        :selectedOption="modelValue.rimBrand"
        @change="(value) => updateField('rimBrand', value)"
      />
    </div>

    <div class="mt-7">
      <p class="block small mt-4 mb-1">Other Requests & information <span class="text-gray-400 font-normal text-xs">optional</span></p>
      <textarea 
        :value="modelValue.otherRequests"
        @input="updateField('otherRequests', $event.target.value)"
        rows="3"
        placeholder="Please enter type of bike, intended terrain and purpose of the wheelset. Also other requests – e.g., Subtle design on rims, Loud freehub, Sturdy rims"
        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gravaadarkbrown"
      ></textarea>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  product: {
    type: Object,
    required: true
  },
  modelValue: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['update:modelValue', 'updateUrl'])

// Parse JSON options from metafields
const wheelsetOptions = computed(() => {
  const parseOptions = (metafield) => {
    if (!metafield?.value) return []
    try {
      // Shopify returns double-encoded JSON, so parse twice
      let parsed = JSON.parse(metafield.value)
      // If it's still a string, parse again
      if (typeof parsed === 'string') {
        parsed = JSON.parse(parsed)
      }
      return Array.isArray(parsed) ? parsed : []
    } catch (error) {
      console.error('Error parsing metafield:', metafield?.value, error)
      return []
    }
  }

  return {
    riderWeight: parseOptions(props.product.wheelsetRiderWeightOptions),
    rimType: parseOptions(props.product.wheelsetRimTypeOptions),
    rimHeight: parseOptions(props.product.wheelsetRimHeightOptions),
    tireWidth: parseOptions(props.product.wheelsetTireWidthOptions),
    rimBrand: parseOptions(props.product.wheelsetRimBrandOptions)
  }
})

const hasCustomFields = computed(() => {
  return wheelsetOptions.value.riderWeight.length > 0 ||
         wheelsetOptions.value.rimType.length > 0 ||
         wheelsetOptions.value.rimHeight.length > 0 ||
         wheelsetOptions.value.tireWidth.length > 0 ||
         wheelsetOptions.value.rimBrand.length > 0
})

const updateField = (field, value) => {
  emit('update:modelValue', {
    ...props.modelValue,
    [field]: value
  })
  
  // Also update URL query parameters
  emit('updateUrl', field, value)
}
</script>
